import { useCallback } from 'react';

import { Box } from '@components/Restyle';
import theme from '@themes/theme';

interface UseContactListSpacersArgs {
  headerSpace?: keyof typeof theme.spacing;
  footerSpace?: number;
  showEmptyStateNoSearch?: boolean;
}

/**
 * Shared `ListHeaderComponent`/`ListFooterComponent` render props for the
 * `ContactList`/`ContactListMobile`/`ContactListV3` family — identical
 * logic across all three (TA-10789, byte-identical duplication tripped
 * SonarCloud's new-code duplication gate when inlined separately).
 */
export const useContactListSpacers = ({
  headerSpace,
  footerSpace,
  showEmptyStateNoSearch,
}: UseContactListSpacersArgs) => {
  const renderListHeader = useCallback(
    () => (headerSpace ? <Box marginBottom={headerSpace} /> : null),
    [headerSpace]
  );

  const renderListFooter = useCallback(
    () =>
      showEmptyStateNoSearch ? undefined : (
        <Box
          style={{
            paddingBottom:
              footerSpace !== undefined
                ? footerSpace
                : theme.spacing.listFooter,
          }}
        />
      ),
    [showEmptyStateNoSearch, footerSpace]
  );

  return { renderListHeader, renderListFooter };
};
